
<div  class="val-attente-operation"
      [ngClass]="{'val-invisible': !visible}">
  <kendo-loader type="converging-spinner"
                themeColor="info"
                size="large">
  </kendo-loader>
</div>

